var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDownloadIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.523438 17.5C0.523438 17.2239 0.747295 17 1.02344 17H18.0234C18.2996 17 18.5234 17.2239 18.5234 17.5V18.5C18.5234 18.7761 18.2996 19 18.0234 19H1.02344C0.747295 19 0.523438 18.7761 0.523438 18.5V17.5ZM10.5234 11.172L16.2409 5.45361C16.4361 5.25832 16.7527 5.25831 16.948 5.45358L17.6549 6.16047C17.8502 6.35572 17.8502 6.67229 17.6549 6.86755L9.87699 14.6464C9.68173 14.8417 9.36513 14.8417 9.16986 14.6464L1.39187 6.86843C1.19665 6.67322 1.1966 6.35673 1.39174 6.16145L2.09891 5.45377C2.29414 5.25841 2.6108 5.25834 2.80612 5.45362L8.52344 11.17V0.5C8.52344 0.223857 8.7473 0 9.02344 0H10.0234C10.2996 0 10.5234 0.223858 10.5234 0.5V11.172Z",
    fill: "#26ABE1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/downloadIcon.9afb6734.svg";
export { ForwardRef as ReactComponent };